export const RECENT_PRODUCT_WINDOW_MONTHS = 3;

const parseProductDate = (value) => {
  if (!value) return null;

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed;
  }

  return null;
};

export const isProductRecentlyAdded = (createDate, windowMonths = RECENT_PRODUCT_WINDOW_MONTHS) => {
  const createdAt = parseProductDate(createDate);
  if (!createdAt) return false;

  const now = new Date();
  const cutoff = new Date(now);
  cutoff.setMonth(now.getMonth() - windowMonths);

  return createdAt >= cutoff && createdAt <= now;
};
